import { http, pollStatus } from '@pendo/http';

export function importLocalizationFile (subscriptionId, homeViewId, langCode, fileData) {
    const headers = {
        'Content-Type': 'application/xml; charset=UTF-8',
    };

    return http
        .post(`api/s/${subscriptionId}/resourcecenter/${homeViewId}/localization/importasync/${langCode}`, fileData, {
            headers,
            credentials: 'same-origin',
        })
        .then((resp) => resp.data);
}

export function fetchTranslationStatus (homeViewId, shouldStopPolling) {
    const endpoint = `/api/s/_SID_/resourcecenter/${homeViewId}/localization/status`;

    return pollStatus(endpoint, shouldStopPolling, 2);
}

export function clearTranslatedStrings (homeViewId, langCode) {
    return http
        .post(`api/s/_SID_/resourcecenter/${homeViewId}/localization/clear/${langCode}`)
        .then((resp) => resp.data);
}

export function getTranslatedResourceCenter (homeViewId, languageCode) {
    return http
        .get(`api/s/_SID_/resourcecenter/${homeViewId}`, { params: { langCode: languageCode } })
        .then((translatedSteps) => translatedSteps.data);
}

export function loadRCTranslations (homeViewId, langCode) {
    return http.get(`api/s/_SID_/resourcecenter/${homeViewId}/localization/translations/${langCode}`).then((res) => res.data);
}

export function createRCTranslations (homeViewId, langCode) {
    return http.post(`api/s/_SID_/resourcecenter/${homeViewId}/localization/translations/${langCode}`).then((res) => res.data);
}

export function saveRCTranslations (homeViewId, langCode, translations) {
    return http
        .put(`api/s/_SID_/resourcecenter/${homeViewId}/localization/translations/${langCode}`, translations)
        .then((res) => res.data);
}
